/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const jazeemInventoryEvents = /* GraphQL */ `subscription JazeemInventoryEvents {
  jazeemInventoryEvents {
    events {
      eventId
      timestamp
      asin
      process
      storeId
      operation
      locationType
      locationId
      storeType
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.JazeemInventoryEventsSubscriptionVariables,
  APITypes.JazeemInventoryEventsSubscription
>;
